"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentersPremiumOutputWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var commonFunctions_1 = require("../../../commonFunctions");
var RentersPricingExplainedRenderers_1 = require("../../../components/modals/renderers/RentersPricingExplainedRenderers");
var RentersPremiumOutputWidget = /** @class */ (function (_super) {
    __extends(RentersPremiumOutputWidget, _super);
    function RentersPremiumOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.resize = function () {
            _this.setState({
                bgHeight: _this.getBgHeight()
            });
        };
        _this.state = {
            bgHeight: 0
        };
        return _this;
    }
    RentersPremiumOutputWidget.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.resize);
        window.addEventListener('scroll', this.resize);
        this.setState({
            bgHeight: this.getBgHeight() + 100
        });
    };
    RentersPremiumOutputWidget.prototype.render = function () {
        return (React.createElement("div", { className: "premium-output mb-0" },
            React.createElement("div", { className: "top-section" },
                React.createElement("div", { className: "premium-info" }, this.renderFirstMonthPrice()),
                this.renderBackgroundAligner()),
            React.createElement("div", { className: "bottom-section" }, this.renderQuestions())));
    };
    RentersPremiumOutputWidget.prototype.renderFirstMonthPrice = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: "price", className: "price text-center font-family-display font-weight-bold" }, "".concat((0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.premium)),
                React.createElement("span", { className: "text-center font-weight-medium fs-16" },
                    " / month",
                    React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-3", title: "Pricing explained" }, (0, RentersPricingExplainedRenderers_1.renderRentersPricingExplained)(this.props.interaction)))),
            React.createElement("div", { className: "text-center font-weight-extra-light fs-16" },
                React.createElement("div", { className: "mt-2" },
                    "You won\u2019t pay more than",
                    React.createElement("b", { className: "font-weight-semi-bold" },
                        " ",
                        (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.neverHigher),
                        " / month for the next 3 months "),
                    "based on your current details and your",
                    React.createElement("b", { className: "font-weight-semi-bold" }, " price could go down"),
                    "!"),
                React.createElement("div", { className: "mt-3" }, "All figures include Insurance Premium Tax."))));
    };
    RentersPremiumOutputWidget.prototype.renderBackgroundAligner = function () {
        return (React.createElement("div", { className: "bg-wrapper" },
            React.createElement("div", { className: "bg", style: { height: this.state.bgHeight } },
                React.createElement("img", { className: "waves", src: "/img/Flow-waves.svg", alt: "Journey background waves" })),
            React.createElement("img", { className: "clouds-back", src: "/img/Flow-clouds-back.svg", alt: "Journey background clouds back" }),
            React.createElement("img", { className: "clouds-front", src: "/img/Flow-clouds-front.svg", alt: "Journey background clouds front" }),
            React.createElement("div", { className: "bg-fix" })));
    };
    RentersPremiumOutputWidget.prototype.renderQuestions = function () {
        return React.createElement(plugin_journey_1.QuestionList, __assign({}, this.props, { questions: this.props.question.questions }));
    };
    RentersPremiumOutputWidget.prototype.getBgHeight = function () {
        var background = document.getElementsByClassName("bg")[0];
        if (!background) {
            return 0;
        }
        return background.getBoundingClientRect().bottom;
    };
    return RentersPremiumOutputWidget;
}(React.Component));
exports.RentersPremiumOutputWidget = RentersPremiumOutputWidget;
//# sourceMappingURL=RentersPremiumOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/RentersPremiumOutputWidget.js
// module id = 2551
// module chunks = 0